import React from 'react';
import {
  Typography, Button, Box, Stack, Container,
} from '@mui/material';
import { Typography700, ImgBox } from 'views/common/components';

import PATHS from 'lib/navigation/paths';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import StyledBox from 'views/rebranded-module/common/components/Logical/ErrorPageV2/ErrorPageV2.styles';
import Typography500 from 'views/common/components/UI/Typography500';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import useGenerateErrorPageHreflangs from 'views/common/hooks/useGenerateErrorPageHreflangs';

const ErrorPageV2 = (props) => {
  const { statusCode = 500, title, subtitle } = props;
  const { t } = useTranslation();
  const getSizedImage = useAdabtiveMultiSizeImage();
  const { hreflangData } = useSelector((state) => state.globalData);
  useGenerateErrorPageHreflangs();

  const erroBG = {
    large_url: 'imgs/Rebranding/ErrorPage/ErrorBG.jpg',
    medium_url: 'imgs/Rebranding/ErrorPage/ErrorBG.jpg',
    small_url: 'imgs/Rebranding/ErrorPage/ErrorBG_sm.jpg',
  };

  return (
    <>
      {hreflangData && (
        <>
          <link rel="canonical" href={hreflangData?.canonical} />
          {hreflangData.urls?.map((local) => (
            <link
              key={local.hreflang}
              rel="alternate"
              href={local.url}
              hrefLang={local.hreflang}
            />
          ))}
        </>
      )}
      <StyledBox>
        <Box className="EPImage">
          <ImgBox
            image={{
              src: getSizedImage(erroBG),
              alt: title,
            }}
            objectFit="cover"
            unoptimized
          />
        </Box>
        <Box className="EPTransparent" />
        <Container maxWidth="xxl">
          <Box className="EPContent">
            <Typography
              variant="h1"
              component="p"
              className="EPStatusCodeTxt"
              textAlign="center">
              {statusCode}
            </Typography>
            <Stack gap={2} alignItems="center">
              <Typography700 variant="h2" component="p" className="EPTitle">
                {title
                  || t(`common_layout_v2:errors.error_${statusCode}.header`)}
              </Typography700>

              <Typography500
                variant="body1"
                component="p"
                className="EPDescription">
                {subtitle
                  || t(`common_layout_v2:errors.error_${statusCode}.description`)}
              </Typography500>
              <Button
                href={PATHS.home()}
                variant="contained"
                color="primary"
                component={NavigatorLink}>
                {t('common_layout_v2:errors.home')}
              </Button>
            </Stack>
          </Box>
        </Container>
      </StyledBox>
    </>
  );
};

export { ErrorPageV2 };
